import { useQuery } from 'react-query'

import { IFilter } from 'src/components/filter/types/filter.types'
import ProductService from 'src/services/product.service'

import { removeDefaultParams } from 'src/common/utils'
import { QUERY_KEYS } from 'src/constants'
import { useParams } from 'react-router-dom'

const initialProductsFilter: IFilter = {
  query: '',
  step: ['all'],
  journey: ['all'],
  impact: ['all'],
  public: ['all'],
  ai_generated: ['all'],
}

const useProducts = (filter?: IFilter) => {
  const { accountId } = useParams()

  return useQuery(
    [QUERY_KEYS.PRODUCTS, accountId, filter ?? ''],
    async () => {
      if (filter) {
        return await ProductService.getFilteredProducts(
          removeDefaultParams({ ...filter, account: accountId }, initialProductsFilter),
        )
      }

      return await ProductService.getProducts({ account: accountId })
    },
    {
      keepPreviousData: true,
    },
  )
}

export { useProducts, initialProductsFilter }
